export default "__VITE_ASSET__BUVhWjJa__"